module.exports = __webpack_public_path__ + "static/media/galeryGrass2.a8948149.jpg";